import React from 'react'
import './history-log-fall-2023.css'

const formatStatusHistoryDate = (value) => {
    if (!value) return ''

    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return ''

    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
}

const formatHistoryTitle = (log) => {
    const subject = log.entityType === 'student'
        ? (log.studentName || 'Student')
        : ''

    if (log.previousStatus) {
        return subject
            ? `${subject}: ${log.previousStatus} -> ${log.status}`
            : `${log.previousStatus} -> ${log.status}`
    }

    return subject
        ? `${subject}: ${log.status}`
        : `${log.status}`
}

const HistoryLogFall2023 = ({ log }) => {
    const showReason = log.status === 'Inquired' && log.reason

    return (
        <div className='history-log-fall-2023'>
            <div className='history-log-fall-2023__top-row'>
                <div className='history-log-fall-2023__date'>{formatStatusHistoryDate(log.effectiveDate || log.date)}</div>
            </div>
            {showReason && <div className='history-log-fall-2023__reason'>{log.reason}</div>}
            <div className='history-log-fall-2023__title'>{formatHistoryTitle(log)}</div>
            {log.note && <div className='history-log-fall-2023__note'>{log.note}</div>}
        </div>
    )
}

export default HistoryLogFall2023
